import axios from '../axios';

export const show = (lang) => {
  return axios.get(`/shareholders-communication?lang=${lang}`);
};

export const submit = (payload) => {
  return axios.post('/shareholders-communication', payload);
};
